import { render } from "./whats-new.vue?vue&type=template&id=41c45861&lang=pug"
import script from "./whats-new.vue?vue&type=script&setup=true&lang=js"
export * from "./whats-new.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__